import React from 'react';

import useProducts from '../../../hooks/useProducts';
import NeddedProduct from '../../common/products/neddedProducts';
import { priceIva } from '../../../middleware/iva';
import {
  getRandomNumber,
  formatNumber,
} from '../../../middleware/common-functions';

const RelatedProducts = ({ cart_products, updateCart }) => {
  const related_types = cart_products
    .map((item) => {
      const type = item.details.find((i) => i.name == 'Tipo');
      return type ? type.value : null;
    })
    .filter((i) => i);

  const rand = getRandomNumber(0, related_types.length - 1);
  const { result: products } = useProducts({
    grpsbi: [related_types[rand]],
    limit: 6,
  });

  const currentLocation = JSON.parse(localStorage.getItem('location') || '{}');

  return (
    <div className="related-products-section">
      <div className="related-products-header">
        <h3 className="related-products-title">
          <i className="fas fa-lightbulb mr-2"></i>
          Productos Relacionados
        </h3>
        <p className="related-products-subtitle">
          Descubre productos que complementan tu selección
        </p>
      </div>

      <div className="related-products-grid">
        {products &&
          Object.keys(products).map((key) => {
            const item = products[key];
            const stock = item.zoneAvail?.find(
              (z) => z.xiaz_id === currentLocation.id
            );
            if (!stock || stock.cantex <= 0) return null;
            item.price_num = priceIva(item.zonePrice);
            item.price = formatNumber(item.price_num);

            return (
              <div key={item.id} className="related-product-card">
                <NeddedProduct
                  product={item}
                  type="related"
                  updateCart={updateCart}
                />
              </div>
            );
          })}
      </div>

      {(!products || Object.keys(products).length === 0) && (
        <div className="no-related-products">
          <i className="fas fa-search text-muted"></i>
          <p>No hay productos relacionados disponibles</p>
        </div>
      )}
    </div>
  );
};

export default RelatedProducts;
